import { useEffect, useState } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import apiClient from '../../global/utils/apiClient'
import { useMetaStore } from '../../scoring/store/MetaStore'
import { useAdminStore } from '../store/AdminStore'
import PrizeAdminView from '../views/PrizeAdminView'

function PrizeAdminController() {
  const orgId = useAdminStore((state) => state.orgId)
  const [searchParams] = useSearchParams()
  const prizeId = searchParams.get('prizeId')
  const [eventList, setEventList] = useState([])
  const [prizeData, setPrizeData] = useState({
    roundId: '',
    prizeType: 0,
    prizeMoney: 0,
    orgId: orgId,
    golferId: '',
    eventId: '',
    golferName: ''
  })
  const [roundList, setRoundList] = useState([])
  const setGlobalModal = useMetaStore((state) => state.setGlobalModal)
  const navigate = useNavigate()

  useEffect(() => {
    if (orgId) {
      apiClient.get(`/gskapi/event/org/${orgId}`).then((res) => {
        setEventList(res.data)
      })
    }
  }, [orgId])

  useEffect(() => {
    if (prizeData.eventId) {
      console.log('Loading round list for event:', prizeData.eventId)
      loadRoundList(prizeData.eventId)
    }
  }, [prizeData.eventId])

  useEffect(() => {
    if (prizeId) {
      apiClient.get(`/gskapi/prizes/find/${prizeId}`)
        .then((res) => {
          if (res.data) {
            setPrizeData(res.data)
          }
        })
        .catch((error) => console.error('Error fetching prize details:', error))
    }
  }, [prizeId])

  const loadRoundList = async (eId) => {
    const rounds = await apiClient.get(`/gskapi/rounds/byevent/${eId}`)
    setRoundList(rounds.data)
  }

  const handleChange = (e) => {
    const { name, value } = e.target
    if (name === 'roundId') {
      const selectedRound = roundList.find((r) => r.roundId === value)
      setPrizeData({
        ...prizeData,
        [name]: value,
        golferName: selectedRound ? selectedRound.golferName : '',
        golferId: selectedRound ? selectedRound.golferId : ''
      })
    } else {
      setPrizeData({ ...prizeData, [name]: value })
    }
  }

  const handleEventChange = (e) => {
    setPrizeData({
      ...prizeData,
      eventId: e?.target?.value,
    })
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    try {
      const res = await apiClient.post('/gskapi/prizes/save', prizeData)
      if (res.status === 200 || res.status === 201) {
        setGlobalModal(true, 'Save Successful', '#060')
        navigate('/admin/prizes')
      } else {
        setGlobalModal(true, 'Failed to save prize data.', '#900')
      }
    } catch (error) {
      console.error('Error saving prize data:', error)
      setGlobalModal(true, 'Error saving prize data.', '#900')
    }
  }

  const handleDelete = async () => {
    try {
      const res = await apiClient.post('/gskapi/prizes/delete', { prizeId: prizeData.prizeId })
      if (res.status === 200) {
        navigate('/admin/prizes')
      }
    } catch (error) {
      console.error('Error deleting prize:', error)
      setGlobalModal(true, 'Error deleting prize.', '#900')
    }
  }

  return (
    <PrizeAdminView
      prizeData={prizeData}
      handleChange={handleChange}
      handleSubmit={handleSubmit}
      roundList={roundList}
      handleDelete={handleDelete}
      eventList={eventList}
      handleEventChange={handleEventChange}
      eventId={prizeData.eventId}
    />
  )
}

export default PrizeAdminController
